import { useEffect, useRef, useState } from "react";
import useScreenSize from "../utilities/getDimentions";
import { strLang } from "../functions/strLang";
import { useSwipeable } from "react-swipeable";
import ActivityCard from "./components/ActivityCard";
import CreateActivity from "./components/CreateActivity";
import { getDaysOfMonth } from "../utilities/getCurrentDate";
import { getMainInfo } from "../services/menu";
import { updateUser } from "../services/territories";
import { emptys, user } from "../data/main";
import {
  saveWarningSeen,
  warningWasShowed,
} from "../functions/warningFunctions";
import { colorsList } from "../data/colorsList";
import { isEditor } from "../functions/isEditor";

const dayName = strLang("daysName");
const dayNameShort = strLang("daysNameShort");
var mapsList = [];
var tempHour = false;
var scrollPosition = 0;

const getCurrentMonth = () => {
  let today = new Date();
  let month = today.getMonth() + 1;
  return [today.getFullYear(), month];
};

export default function useSchedule({
  openMainMsg,
  openMap,
  login,
  maps,
  users,
}) {
  const screenSize = useScreenSize();
  const [currentDate, setCurrentDate] = useState(getCurrentMonth());
  const [currentAct, setCurrentAct] = useState({ id: false, data: [] });
  const [open, setOpen] = useState(false);
  const [calendarDays, setCalendarDays] = useState({});
  const [selectedTer, setSelectedTer] = useState({ id: false, name: false });
  const [leaders, setLeaders] = useState(
    Array.isArray(users) ? users.filter((a) => a.LEAD) : []
  );
  const [dm, setDm] = useState(screenSize.width > 960 ? dayName : dayNameShort);
  const [secondFlex, setSecondFlex] = useState({
    active: screenSize.width <= 960,
    size:
      screenSize.width <= 960
        ? screenSize.width < screenSize.height
          ? "v"
          : "h"
        : false,
  });
  const eventColors = [
    {
      value: "#FFE8CC",
      color: "#FFE8CC",
      label: strLang("colorsList").orange,
    },
    {
      value: "#CCD3FF",
      color: "#CCD3FF",
      label: strLang("colorsList").blue,
    },
    {
      value: "#FFD7D7",
      color: "#FFD7D7",
      label: strLang("colorsList").red,
    },
    {
      value: "#DFDFDF",
      color: "#DFDFDF",
      label: strLang("colorsList").gray,
    },
    {
      value: "#FFF366",
      color: "#FFF366",
      label: strLang("colorsList").yellow,
    },
    {
      value: "#FCC7FF",
      color: "#FCC7FF",
      label: strLang("colorsList").violet,
    },
  ];

  const secondBox = useRef();

  const handleScroll = (element) => {
    let tbodyRef = document
      .getElementById("calendarTable")
      .getElementsByTagName("tbody")[0];
    if (tbodyRef.rows.length > 0) {
      const position = element.target.scrollTop;
      scrollPosition = position;
    }
  };

  const handlers = useSwipeable({
    onSwipedLeft: () => {
      scrollPosition = 0;
      startWritingCalendar(findNextMonth(currentDate, true));
    },
    onSwipedRight: () => {
      scrollPosition = 0;
      startWritingCalendar(findNextMonth(currentDate));
    },
    swipeDuration: 500,
    preventScrollOnSwipe: true,
    trackMouse: true,
  });

  useEffect(() => {
    if (Array.isArray(users)) {
      setLeaders([...users.filter((a) => a.LEAD)]);
    }
  }, [users]);

  useEffect(() => {
    if (screenSize.width > 960) {
      setSecondFlex({ active: false, size: false });
      if (secondFlex.active) {
        setDm(dayName);
      }
    } else {
      setSecondFlex({
        active: true,
        size: screenSize.width < screenSize.height ? "v" : "h",
      });
      if (!secondFlex.active) {
        setDm(dayNameShort);
      }
    }
  }, [screenSize]);

  useEffect(() => {
    if (login) {
      setOpen("loading");
    } else {
      closeMsg();
    }
  }, [login]);

  useEffect(() => {
    if (maps) {
      mapsList = [...maps];
      findCalendarInfo(currentDate);
    }
  }, [maps]);

  const findNextMonth = (value, increase = false) => {
    if (increase) {
      value[1]++;
    } else {
      value[1]--;
    }
    if (value[1] < 1) {
      value[1] = 12;
      value[0]--;
    }
    if (value[1] > 12) {
      value[1] = 1;
      value[0]++;
    }
    return value;
  };

  const updateDay = (value, data = null) => {
    setCurrentAct({ id: value, data: data ?? calendarDays.data[value] ?? [] });
  };

  const askEdit = (data, forceAsk) => {
    const { id, date, ter } = data;

    if (!(!isEditor && id === "")) {
      if (date && calendarDays.data[date]) {
        updateDay(date);
      }
      if (!secondFlex.active || forceAsk) {
        setSelectedTer({
          ...data,
          ter: {
            value: data.ter !== "" ? Number(data.ter) : "",
            label: data.ter !== "" ? data.name : "",
          },
          leader: {
            value: data.leader,
            label: data.person,
          },
          color: {
            value: data.color,
            label: eventColors.filter((e) => e.value === data.color)[0]?.label,
          },
          type: ter !== "" ? "ter" : "event",
          info: data.info,
        });
        setOpen("openSchedule");
      }
    }
  };

  const goToMap = () => {
    const { id, ter = {}, name, date } = selectedTer;
    user.schedule = {
      id,
      name,
      ter,
      date,
    };
    openMap({ id: ter?.value, name, screen: "map" });
    updateUser(ter?.value);
    closeMsg();
  };

  const askActivity = (value) => {
    setSelectedTer({
      id: "",
      ter: false,
      status: 3,
      date: value,
      hour: tempHour ?? "",
    });
    setOpen("whatInsert");
  };

  const openEditor = (type) => {
    if (type) {
      setSelectedTer({ ...selectedTer, type });
    }
    setOpen("openEditor");
  };

  const updateActivityInfo = async () => {
    try {
      setOpen("loading");
      const { id, info } = selectedTer;

      let payload = {
        type: "updateActivityInfo",
        id,
        info: info.replace('"', "ʺ"),
      };
      console.log("payload", payload);
      let responseActivity = await getMainInfo(payload);
      // console.log(responseActivity);
      if (responseActivity.status) {
        reloadCalendar();
      } else {
        openError();
      }
    } catch (error) {
      console.log("updateActivityInfo error: ", error);
      openError();
    }
  };

  const updateActivity = async () => {
    if (
      emptys.includes(
        selectedTer.type === "ter" ? selectedTer.ter.value : selectedTer.name
      ) ||
      emptys.includes(selectedTer.date) ||
      emptys.includes(selectedTer.hour)
    ) {
      let fieldName = emptys.includes(
        selectedTer.type === "ter" ? selectedTer.ter.value : selectedTer.name
      )
        ? strLang(selectedTer.type === "ter" ? "territory" : "name")
        : emptys.includes(selectedTer.date)
        ? strLang("date")
        : emptys.includes(selectedTer.hour)
        ? strLang("hour")
        : "";
      openMainMsg({ label: `${strLang("missingField")} ${fieldName}` });
    } else {
      setOpen("loading");
      const { id, name, leader, info, ter, date, hour, status, color, type } =
        selectedTer;
      tempHour = hour;
      let LEADNAME =
        leader?.value > 0
          ? leaders.filter((e) => e.ORD === Number(leader.value))[0]?.NOMBRE
          : "";

      let payload = {
        type: "addActivity",
        code: localStorage.getItem("code2"),
        COD: id,
        GRUPO: type === "ter" ? 0 : localStorage.getItem("code2"),
        TER: type === "ter" ? ter.value : "",
        NOMBRE: type === "ter" ? "" : name.replace('"', "ʺ"),
        FECHA: date + " " + hour,
        STA: status,
        COLOR: color?.value,
        LEAD: leader?.value,
        LEADNAME,
        EXTRATEXT: info ? info.replace('"', "ʺ") : "",
      };
      // console.log("payload", payload);
      let responseActivity = await getMainInfo(payload);
      // console.log(responseActivity);
      if (responseActivity.status) {
        reloadCalendar();
      } else {
        openError();
      }
    }
  };

  const startDelete = async () => {
    setOpen("loading");
    let payload = {
      type: "deleteActivity",
      code: localStorage.getItem("code2"),
      COD: selectedTer.id,
    };
    //console.log("payload", payload);
    let responseActivity = await getMainInfo(payload);
    //console.log(responseActivity);
    if (responseActivity.status) {
      reloadCalendar();
    } else {
      openError();
    }
  };

  const findCalendarInfo = async (dateValue) => {
    let actDate = [...dateValue];
    let prevMonth =
      actDate[1] === 1 ? [actDate[0] - 1, 12] : [actDate[0], actDate[1] - 1];
    prevMonth[1] = prevMonth[1] < 10 ? "0" + prevMonth[1] : prevMonth[1];

    let nextMonth =
      actDate[1] === 12 ? [actDate[0] + 1, 1] : [actDate[0], actDate[1] + 1];
    nextMonth[1] = nextMonth[1] < 10 ? "0" + nextMonth[1] : nextMonth[1];

    let theMonths = {
      previous: prevMonth.join("-"),
      current: `${actDate[0]}-${
        actDate[1] < 10 ? "0" + actDate[1] : actDate[1]
      }`,
      next: nextMonth.join("-"),
    };

    setCurrentDate(actDate);
    let days = getDaysOfMonth({ year: dateValue[0], month: dateValue[1] });

    let countDay = days.dayWeek ? days.lastDays - days.dayWeek + 1 : 1;

    let responseActivity = await getMainInfo({
      type: "activity",
      code: localStorage.getItem("code2"),
      id: localStorage.getItem("id"),
      start:
        countDay === 1
          ? `${theMonths.current}-01`
          : `${theMonths.previous}-${countDay}`,
      days: countDay === 1 ? days.days + 6 : days.dayWeek + 1 + days.days + 5,
    });
    // console.log("responseActivity: ", responseActivity);
    let tempData = {};
    if (responseActivity.status) {
      responseActivity.activity.sort((a, b) =>
        a.FECHA < b.FECHA ? -1 : a.FECHA > b.FECHA ? 1 : 0
      );

      responseActivity.activity.forEach((o) => {
        const {
          FECHA,
          TER,
          STA,
          COD,
          NOM,
          NOMBRE,
          COLOR,
          DONE,
          TOTAL,
          EXTRATEXT,
          LEAD,
          PERSON,
          DESCRIP,
        } = o;
        var dateSplit = FECHA.split(" ");
        var writeData = false;

        if (!tempData.hasOwnProperty(dateSplit[0])) {
          tempData[dateSplit[0]] = [];
          writeData = true;
        } else if (
          tempData[dateSplit[0]].findIndex((p) => p.ter === TER) === -1 ||
          STA === 3
        ) {
          if (STA === 3) {
            tempData[dateSplit[0]] = tempData[dateSplit[0]].filter(
              (v) => !(v.ter === TER && v.status !== 3)
            );
          }
          writeData = true;
        }

        if (writeData) {
          var extraDates = false;
          if (TER > 0) {
            const currentDateSplit0 = dateSplit[0];
            extraDates = responseActivity.activity
              .filter(
                (s) =>
                  s.TER === TER &&
                  s.STA < 3 &&
                  s.FECHA.split(" ")[0] === currentDateSplit0 &&
                  s.FECHA2.split(" ")[0] === currentDateSplit0
              )
              .sort((a, b) =>
                a.FECHA2 < b.FECHA2 ? -1 : a.FECHA2 > b.FECHA2 ? 1 : 0
              );
            if (extraDates.length > 0) {
              extraDates = {
                initial: extraDates[0].FECHA.split(" ")[1],
                final: extraDates[extraDates.length - 1].FECHA2.split(" ")[1],
                done: extraDates[extraDates.length - 1].DONE,
                total: extraDates[extraDates.length - 1].TOTAL,
              };
            } else {
              extraDates = false;
            }
          }
          var terData = mapsList.filter((e) => e.ID === Number(TER));
          tempData[dateSplit[0]].push({
            id: COD,
            name: TER ? NOM : NOMBRE,
            ter: TER,
            status: STA,
            hour: dateSplit[1],
            color: COLOR,
            finish: 0,
            done: extraDates ? extraDates.done : DONE,
            total: extraDates ? extraDates.total : TOTAL,
            terDone: terData[0]?.HECHOS ?? 0,
            terTotal: terData[0]?.TOTAL ?? 0,
            extraDates,
            info: EXTRATEXT,
            leader: LEAD,
            person: PERSON,
            descrip: DESCRIP,
          });
        }
      });
    }
    setCalendarDays({
      ...days,
      ...theMonths,
      data: tempData,
    });
    changeTableScroll();
    return tempData;
  };

  const changeTableScroll = () => {
    try {
      document.getElementById("tableBox").scrollTop = scrollPosition;
    } catch (error) {
      console.log("changeTableScroll error: ", error);
    }
    closeMsg();
  };

  const startWritingCalendar = async (value, reload = false) => {
    setOpen("loading");
    const daysData = await findCalendarInfo(value);
    if (reload) {
      updateDay(currentAct.id, daysData[currentAct.id]);
    } else {
      setCurrentAct({ id: false, data: [] });
    }
  };

  const reloadCalendar = () => {
    startWritingCalendar(currentDate, true);
  };

  const openError = () => {
    setOpen("error");
  };

  const closeMsg = () => {
    setOpen(false);
    setSelectedTer({ id: false, name: false });
  };

  const openWarningMsg = ({
    id = selectedTer.ter?.value,
    name,
    descrip,
    save = true,
  }) => {
    if (descrip) {
      setSelectedTer({ ...selectedTer, name, descrip });
    }
    if (save && id) {
      saveWarningSeen(id);
    }
    setOpen("openWarning");
  };

  const updateTer = (values) => setSelectedTer({ ...selectedTer, ...values });

  const msgType = {
    openSchedule: {
      title: selectedTer.name,
      buttons: [
        selectedTer.ter?.value !== "" && {
          label: strLang("open"),
          func:
            !warningWasShowed(selectedTer.ter?.value) && selectedTer.descrip
              ? openWarningMsg
              : goToMap,

          width: 80,
        },
        selectedTer.status === 3 && !selectedTer.extraDates
          ? (isEditor || selectedTer.leader?.value === Number(user.id)) && {
              label: strLang("edit"),
              func: isEditor ? () => openEditor() : () => setOpen("infoEditor"),
              width: 80,
              color: colorsList.green,
            }
          : null,
        {
          label: strLang("cancel"),
          func: closeMsg,
          width: 80,
          color: colorsList.darkGrey,
        },
      ],
    },
    whatInsert: {
      title: strLang("whatInsert"),
      buttons: [
        {
          label: strLang("territory"),
          func: () => openEditor("ter"),
          width: 80,
        },
        {
          label: strLang("event"),
          func: () => openEditor("event"),
          width: 80,
          color: colorsList.green,
        },
        {
          label: strLang("cancel"),
          func: closeMsg,
          width: 80,
          color: colorsList.darkGrey,
        },
      ],
    },
    openEditor: {
      title: selectedTer.id > 0 ? selectedTer.name : strLang("whatInsert"),
      blocked: true,
      inputList: [
        selectedTer.type === "ter"
          ? {
              label: strLang("territory"),
              value: selectedTer.ter,
              style: { width: 300 },
              select: [
                ...mapsList
                  .sort((a, b) => (a.NOM < b.NOM ? -1 : a.NOM > b.NOM ? 1 : 0))
                  .map((e) => {
                    return { value: e.ID, label: e.NOM, calendar: e.HISTORIAL };
                  }),
              ],
              change: (ter) => updateTer({ ter }),
            }
          : {
              label: strLang("event"),
              value: selectedTer.name,
              style: { width: 300 },
              change: (e) => updateTer({ name: e.target.value }),
            },
        {
          label: strLang("date"),
          value: selectedTer.date,
          style: { width: 300 },
          type: "date",
          change: (e) => updateTer({ date: e.target.value }),
        },
        {
          label: strLang("hour"),
          value: selectedTer.hour,
          style: { width: 300 },
          type: "time",
          change: (e) => updateTer({ hour: e.target.value }),
        },
        selectedTer.type === "event" && {
          label: strLang("color"),
          value: selectedTer.color,
          style: { width: 300 },
          select: eventColors,
          change: (color) => updateTer({ color }),
        },
        {
          label: strLang("guide"),
          value: selectedTer.leader,
          style: { width: 300 },
          select: [
            { value: 0, label: "" },
            ...leaders.map((e) => {
              return { value: e.ORD, label: e.NOMBRE };
            }),
          ],
          change: (leader) => updateTer({ leader }),
        },
        {
          label: strLang("notes"),
          value: selectedTer.info,
          textArea: true,
          style: { width: 300, height: 200 },
          change: (e) => updateTer({ info: e.target.value }),
        },
      ],
      buttons: [
        {
          label: selectedTer.id > 0 ? strLang("update") : strLang("add"),
          func: updateActivity,
          width: 80,
        },
        selectedTer.id && {
          label: strLang("delete"),
          func: () => setOpen("askDelete"),
          width: 80,
          color: colorsList.red,
        },
        {
          label: strLang("cancel"),
          func: closeMsg,
          width: 80,
          color: colorsList.darkGrey,
        },
      ],
    },
    infoEditor: {
      title: selectedTer.name,
      blocked: true,
      inputList: [
        {
          label: strLang("notes"),
          value: selectedTer.info,
          textArea: true,
          style: { width: 300, height: 200 },
          change: (e) => updateTer({ info: e.target.value }),
        },
      ],
      buttons: [
        {
          label: strLang("update"),
          func: updateActivityInfo,
          width: 80,
        },
        {
          label: strLang("cancel"),
          func: closeMsg,
          width: 80,
          color: colorsList.darkGrey,
        },
      ],
    },
    askDelete: {
      title: strLang("deleteActivity"),
      label: selectedTer.name,
      buttons: [
        selectedTer.id && {
          label: strLang("delete"),
          func: startDelete,
          width: 80,
          color: colorsList.red,
        },
        {
          label: strLang("cancel"),
          func: closeMsg,
          width: 80,
          color: colorsList.darkGrey,
        },
      ],
    },
    loading: {
      type: "loading",
    },
    openWarning: {
      title: selectedTer.name,
      label: selectedTer.descrip,
      buttons: [
        {
          label: strLang("ok"),
          func: selectedTer.id ? goToMap : closeMsg,
          width: 80,
        },
      ],
    },
    error: {
      type: "error",
      label: strLang("netWorkError"),
    },
  };

  const writeEachDay = () => {
    if (calendarDays.days > 0) {
      let weeks = Math.ceil((calendarDays.days + calendarDays.dayWeek) / 7);
      let outDay = !!calendarDays.dayWeek;
      let counter = calendarDays.dayWeek
        ? calendarDays.lastDays - calendarDays.dayWeek + 1
        : 1;
      let prefix = calendarDays.dayWeek
        ? calendarDays.previous
        : calendarDays.current;
      return Array.from({ length: weeks }).map((_, index) => (
        <tr key={index}>
          {Array.from({ length: 7 }).map((_, idx1) => {
            counter =
              (!index && counter > calendarDays.lastDays) ||
              (index && counter > calendarDays.days)
                ? 1
                : counter;
            if (index === 0 && calendarDays.dayWeek && counter === 1) {
              outDay = false;
              prefix = calendarDays.current;
            } else if (index > 0 && counter === 1) {
              outDay = true;
              prefix = calendarDays.next;
            }
            const cellId = `${prefix}-${
              counter < 10 ? "0" + counter : counter
            }`;
            let innerActivities = calendarDays.data[cellId];
            return (
              <td
                key={idx1}
                onClick={() => updateDay(cellId)}
                className={
                  "tableTd prevent-select" + (outDay ? " outMonth" : "")
                }
                style={{
                  backgroundColor: currentAct.id === cellId ? "#FEFFCC" : "",
                }}
              >
                <div style={{ fontWeight: "bold" }}>{counter++}</div>
                <CreateActivity
                  active={isEditor}
                  onClick={() => askActivity(cellId)}
                  mainClass={"hideIsMobile"}
                />
                {innerActivities &&
                  innerActivities.map((e, idx2) => (
                    <ActivityCard
                      key={idx2}
                      secondFlex={secondFlex}
                      data={{ ...e, date: cellId }}
                      askEdit={askEdit}
                      openWarningMsg={openWarningMsg}
                    />
                  ))}
              </td>
            );
          })}
        </tr>
      ));
    }
  };

  return {
    currentDate,
    setOpen,
    reloadCalendar,
    handleScroll,
    handlers,
    dm,
    writeEachDay,
    secondBox,
    secondFlex,
    currentAct,
    askActivity,
    askEdit,
    msgType,
    open,
    closeMsg,
    startWritingCalendar,
    openWarningMsg,
    selectedTer,
  };
}
